import { Descriptions } from 'antd';
import { down } from 'styled-breakpoints';
import { useBreakpoint } from 'styled-breakpoints/react-styled';
import type { SharedResourceMetadataItem } from '../sharedResourceTypes';

export interface SharedResourceMetadataTableProps {
  items: SharedResourceMetadataItem[];
}

export function SharedResourceMetadataTable(
  props: SharedResourceMetadataTableProps,
) {
  const isMobile = useBreakpoint(down('md'));

  return (
    <Descriptions
      bordered
      column={1}
      size="middle"
      layout={isMobile ? 'vertical' : 'horizontal'}
    >
      {props.items.map(item => (
        <Descriptions.Item key={item.key} label={item.label}>
          {item.value}
        </Descriptions.Item>
      ))}
    </Descriptions>
  );
}
